import { isDate } from 'date-fns';
import moment, { Moment } from 'moment';

export const getValidText = (value: string | undefined): string | undefined => {
    const trimmedValue = value?.trim();
    return trimmedValue?.length === 0 ? undefined : trimmedValue;
};

export const getValidDate = (dateValue: undefined | string | Date): Date | undefined => {
    return isDate(dateValue) ? dateValue : undefined;
};

export const convertMomentToDate = (date: Moment | string | undefined) =>
    moment.isMoment(date) ? date.toDate() : date === '' ? undefined : date;
